import React, { useState } from "react";
import { toast } from "sonner";
import { trackOrder, formatRON } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { ext } from "@/lib/ext";

const STEPS = ["received", "processing", "shipped", "delivered"];

const Track = () => {
  const { lang } = useLang();
  const e = ext[lang];
  const [num, setNum] = useState("");
  const [order, setOrder] = useState(null);

  const submit = async (ev) => {
    ev.preventDefault();
    if (!num.trim()) return;
    try { setOrder(await trackOrder(num.trim())); } catch { setOrder(null); toast.error("Comandă negăsită"); }
  };

  const idx = order ? STEPS.indexOf(order.status) : -1;

  return (
    <main className="mx-auto max-w-2xl px-4 py-10 sm:px-6" data-testid="track-page">
      <h1 className="text-2xl uc font-semibold sm:text-3xl">{e.track}</h1>
      <form onSubmit={submit} className="mt-6 flex border border-border">
        <input value={num} onChange={(ev) => setNum(ev.target.value)} placeholder={e.trackPh} data-testid="track-input"
          className="w-full bg-transparent px-3 py-3 font-mono text-sm uppercase tracking-widest focus:outline-none" />
        <button type="submit" data-testid="track-submit" className="bg-foreground px-6 font-mono text-[11px] uppercase tracking-widest text-white">{e.trackBtn}</button>
      </form>

      {order && (
        <div className="mt-8 border border-border p-6" data-testid="track-result">
          <div className="flex items-center justify-between">
            <span className="font-mono text-sm uppercase tracking-widest">{order.order_number}</span>
            <span className="font-mono text-sm">{formatRON(order.total)}</span>
          </div>
          {order.status === "cancelled" ? (
            <div className="mt-6 font-mono text-xs uppercase tracking-widest text-destructive">{e.status.cancelled}</div>
          ) : (
            <div className="mt-6 flex items-center justify-between">
              {STEPS.map((s, i) => (
                <div key={s} className="flex flex-1 flex-col items-center">
                  <div className={`h-3 w-3 rounded-full ${i <= idx ? "bg-foreground" : "bg-border"}`} />
                  <span className={`mt-2 text-center font-mono text-[9px] uppercase tracking-widest ${i <= idx ? "text-foreground" : "text-muted-foreground"}`}>{e.status[s]}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </main>
  );
};

export default Track;
